import React from "react";
import { PageLayout } from "../components/PageLayout";

import { LazyLoadImage } from "react-lazy-load-image-component";

import "../styles/app.scss";
import "react-lazy-load-image-component/src/effects/blur.css";

import { SocialShareButtons } from "src/components/SocialShareButtons";
import { NewsletterSignup } from "src/components/NewsletterSignup";
import { MapSequence } from "src/components/Map";

// TODO: Fill these in with real URLS:
export const LINKS_TO_CONTENT = {
  stories: {
    newtownCreek: "https://projects.thecity.nyc/hazard-nyc-newtown-creek/",
    meekerPlume: "https://projects.thecity.nyc/hazard-nyc-meeker-avenue-plume/",
    wolffAlport:
      "https://projects.thecity.nyc/hazard-nyc-wolff-alport-chemical-company/",
    gowanusCanal: "https://projects.thecity.nyc/hazard-nyc-gowanus-canal",
  },
  podcasts: {
    newtownCreek:
      "https://www.thecity.nyc/2024/02/14/newtown-creek-superfund-pollution-hazardnyc-faqnyc-podcast",
    meekerPlume:
      "https://www.thecity.nyc/2024/02/14/meeker-avenue-plume-superfund-pollution-hazardnyc-faqnyc-podcast",
    wolffAlport:
      "https://www.thecity.nyc/2024/02/15/wolff-alport-chemical-company-manhattan-project-superfund-pollution-radiation-cancer-hazardnyc-faqnyc-podcast",
    gowanusCanal: "https://www.thecity.nyc/?p=35738",
  },
};

export const Homepage = () => (
  <PageLayout>
    <div className="app">
      <div className="scrolly-container">
        <div className="scrolly-image">
          <LazyLoadImage
            alt=""
            height="100vh"
            src={require(`../assets/images/scrolly-photos/121323_gowanus_canal_2.jpg`)}
            width="100%"
            effect="blur"
            style={{
              objectPosition: "50% 50%",
            }}
          />
        </div>
        <div className="hero is-landing-image is-flex is-flex-direction-column is-justify-content-flex-end">
          <div className="landing-content mx-5">
            <h1 className="headline mb-0">
              Hazard NYC: Toxic Superfund Sites in the Age of Climate Change
            </h1>
            <div className="deck mb-0" style={{ maxWidth: "900px" }}>
              An exploration of the past, present and future of four federal
              Superfund sites and how climate change affects the efforts to
              clean them up.
            </div>

            <SocialShareButtons />
          </div>
        </div>
      </div>
      <NewsletterSignup />
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent:"center", paddingTop:"2em", alignItems:"center"}}>
        <div style={{maxWidth:"500px", marginLeft:"1em", marginRight:"1em"}}>
          <p className="copy" style={{margin:"0"}}>
            New York City is home to four Superfund sites — toxic places where
            contamination is hazardous to human and environmental health. The
            federal government is spearheading their clean-ups, but the effects
            of climate change complicate the process and raise the stakes.
          </p>
        </div>
        <LazyLoadImage
          alt="Hazard NYC"
          style={{
            maxWidth: "130px",
            margin: "1rem 0 0 0",
          }}
          src={require(`../assets/images/hazard.png`)}
          effect="blur"
        />
      </div>
      <div className="hero">
        <div
          className="hero-body container"
          style={{
            maxWidth: "600px",
          }}
        >
          <h2 className="subhead" style={{paddingTop:"0"}}>Talk With Us</h2>
          <p className="copy">
            On Feb. 27, THE CITY will host a free Open Newsroom event at the Brooklyn Public Library to discuss our Hazard NYC reporting. RSVP{" "}
            <a 
            href="https://www.eventbrite.com/e/hazard-nyc-a-talk-on-nycs-toxic-sites-in-the-age-of-climate-change-tickets-826259543537"
            target="_blank"
            rel="noopener noreferrer"
            >
            here
            </a>.
          </p>
          <h2 className="subhead">Listen to our podcasts</h2>
          <div className="buttons">
            <a
              className="button is-warning is-outlined"
              href={LINKS_TO_CONTENT.podcasts.newtownCreek}
              target="_blank"
              rel="noopener noreferrer"
            >
              Newtown Creek
            </a>
            <a
              className="button is-warning is-outlined"
              href={LINKS_TO_CONTENT.podcasts.meekerPlume}
              target="_blank"
              rel="noopener noreferrer"
            >
              Meeker Avenue Plume
            </a>
            <a
              className="button is-warning is-outlined"
              href={LINKS_TO_CONTENT.podcasts.wolffAlport}
              target="_blank"
              rel="noopener noreferrer"
            >
              Wolff-Alport Chemical Company
            </a>
            <a
              className="button is-warning is-outlined"
              href={LINKS_TO_CONTENT.podcasts.gowanusCanal}
              target="_blank"
              rel="noopener noreferrer"
            >
              Gowanus Canal
            </a>
          </div>
          <h2 className="subhead">Read our visual stories</h2>
        </div>
      </div>
      <MapSequence />
    </div>
  </PageLayout>
);
